import React from 'react';
import { Navigate } from 'react-router-dom';
import { useCurrentUser } from 'hooks/use-current-user.hook';
import { ERROR_PATH, ROOT_PATH } from 'shared/consts';

export const DefaultRedirect: React.FC = (): JSX.Element => {
  const [user, loading] = useCurrentUser();

  if (user || loading) {
    return <Navigate to={ROOT_PATH} replace />;
  }

  return <Navigate to={ERROR_PATH} replace />;
};
